import { render, staticRenderFns } from "./GroupBuySuccessDialog.vue?vue&type=template&id=7046a779&scoped=true&"
import script from "./GroupBuySuccessDialog.vue?vue&type=script&lang=js&"
export * from "./GroupBuySuccessDialog.vue?vue&type=script&lang=js&"
import style0 from "./GroupBuySuccessDialog.vue?vue&type=style&index=0&id=7046a779&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7046a779",
  null
  
)

export default component.exports